<router-outlet></router-outlet>
@if (isLoading$ | async) {
  <app-spinner></app-spinner>
}
@if (initApp$ | async) {}
<app-snackbar></app-snackbar>
@if (extendSession$ | async) {}
@if (logoutSession$ | async) {}
